// The variants are actually imported by the theme, but colocating helps finding them more easily.
const pVariants = {
    large: {
        variant: 'text.large',
        marginTop: 0,
        marginBottom: 3,
        maxWidth: '65ch', // This is roughly the optimal line length for reading (~70-75 characters effectively).
    },
    default: {
        variant: 'text.default',
        marginTop: 0,
        marginBottom: 3,
        maxWidth: '70ch', // This is roughly the optimal line length for reading (~80-85 characters effectively).
    },
    small: {
        variant: 'text.small',
        marginTop: 0,
        marginBottom: 3,
        maxWidth: '70ch', // This is roughly the optimal line length for reading (~80-85 characters effectively).
    },
    /**
     * A paragraph styled like a title.
     * Used for short texts in the event directory, such as the year founded.
     */
    title: { variant: 'title.default' },
};
export default pVariants;
/**
 * @typedef {keyof typeof pVariants} PVariants
 */
//# sourceMappingURL=pVariants.js.map